(function () {
  var THRESHOLD = 20000;
  var retryTimer = null;
  var observer = null;

  function formatPHP(value) {
    return '₱' + Number(value || 0).toLocaleString('en-PH');
  }

  function getProgressEl() {
    return document.getElementById('procurement-progress');
  }

  function getButtonEl() {
    return document.getElementById('cart-quickpay');
  }

  function getTotalEl() {
    return (
      document.querySelector('[data-cart-subtotal]') ||
      document.querySelector('.cart-totals__total-value') ||
      document.querySelector('[data-testid="cart-total-value"]')
    );
  }

  function extractTotalFromText(text) {
    if (!text) return 0;
    var match = text.replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
    return match ? Number(match[1]) : 0;
  }

  function updateProcurementUI() {
    var progress = getProgressEl();
    var button = getButtonEl();
    var totalEl = getTotalEl();

    if (!progress || !button || !totalEl) return false;

    var totalText = totalEl.textContent || '';
    var total = extractTotalFromText(totalText);
    var enabled = total >= THRESHOLD;

    progress.textContent = formatPHP(total) + ' of ' + formatPHP(THRESHOLD);

    button.setAttribute('data-cart-quickpay-enabled', enabled ? 'true' : 'false');
    button.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    button.disabled = !enabled;
    button.textContent = 'QuickPay · CoopPay';

    if (enabled) {
      button.classList.remove('is-disabled');
    } else {
      button.classList.add('is-disabled');
    }

    return true;
  }

  function scheduleProcurementUpdate() {
    if (retryTimer) clearTimeout(retryTimer);

    var attempts = 0;
    var maxAttempts = 30;

    function tryUpdate() {
      attempts += 1;

      var ok = updateProcurementUI();
      var totalEl = getTotalEl();
      var totalText = totalEl ? (totalEl.textContent || '') : '';
      var hasPeso = totalText.indexOf('₱') !== -1;
      var hasNumber = /\d/.test(totalText);

      if (ok && hasPeso && hasNumber) return;

      if (attempts < maxAttempts) {
        retryTimer = setTimeout(tryUpdate, 100);
      }
    }

    retryTimer = setTimeout(tryUpdate, 0);
  }

  function attachObserver() {
    if (observer) observer.disconnect();

    observer = new MutationObserver(function () {
      scheduleProcurementUpdate();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function patchFetch() {
    if (window.__cartProcurementFetchPatched) return;
    window.__cartProcurementFetchPatched = true;

    var originalFetch = window.fetch;

    window.fetch = function () {
      var url = arguments[0];

      return originalFetch.apply(this, arguments).then(function (response) {
        if (
          typeof url === 'string' &&
          (
            url.indexOf('/cart/add') !== -1 ||
            url.indexOf('/cart/change') !== -1 ||
            url.indexOf('/cart/update') !== -1 ||
            url.indexOf('/cart.js') !== -1
          )
        ) {
          scheduleProcurementUpdate();
        }

        return response;
      });
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    attachObserver();
    patchFetch();
    scheduleProcurementUpdate();
  });

  document.addEventListener('click', function () {
    scheduleProcurementUpdate();
  });

  document.addEventListener('cart:refresh', function () {
    scheduleProcurementUpdate();
  });

  document.addEventListener('cart:updated', function () {
    scheduleProcurementUpdate();
  });
})();